import type { Key } from 'react-aria-components/Menu';

export type SingleSelectionProps<ItemKey extends Key> = {
  selection?: ItemKey | null;
  defaultSelection?: ItemKey | null;
} & (
  | {
      disallowEmptySelection: true;
      onSelectionChange?: (key: ItemKey) => void;
    }
  | {
      disallowEmptySelection?: false;
      onSelectionChange?: (key: ItemKey | null) => void;
    }
);

export type SelectedKeys<ItemKey extends Key> =
  | readonly ItemKey[]
  | ReadonlySet<ItemKey>;

export type MultipleSelectionProps<ItemKey extends Key> = {
  selection?: SelectedKeys<ItemKey>;
  defaultSelection?: SelectedKeys<ItemKey>;
  disallowEmptySelection?: boolean;
  onSelectionChange?: (keys: Set<ItemKey>) => void;
};

export function toSelectedKeys<ItemKey extends Key>(
  selection: ItemKey | SelectedKeys<ItemKey> | null | undefined,
): Iterable<ItemKey> | undefined {
  if (selection === null) {
    return [];
  }
  if (typeof selection === 'string' || typeof selection === 'number') {
    return [selection];
  }
  return selection;
}

export function toItemKeys<ItemKey extends Key>(
  keys: Iterable<Key>,
): Set<ItemKey> {
  // biome-ignore lint/plugin: react-aria reports keys as Key, but they are the item ids typed as ItemKey.
  const itemKeys = keys as Iterable<ItemKey>;
  return itemKeys instanceof Set ? itemKeys : new Set(itemKeys);
}
